import PermissionButton from "../../components/ui/PermissionButton";
import TableActions from '../../components/ui/TableActions';
import { useState } from 'react';
import StockLotsModal from './StockLotsModal';
export default function InventoryTable({ items, onEdit, onUpdated }) {
  const [lotItem,setLotItem]=useState(null);
  const formatStock = (stock) => {
    const value = Number(stock || 0);

    return Number.isInteger(value)
      ? value.toLocaleString("en-IN")
      : value.toLocaleString("en-IN", {
          maximumFractionDigits: 3,
        });
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/5">
      {lotItem&&<StockLotsModal item={lotItem} onUpdated={onUpdated} onClose={()=>setLotItem(null)}/>}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-black/40 text-gray-400">
            <tr>
              <th className="px-6 py-4 text-left">Item</th>
              <th className="px-6 py-4 text-left">Department</th>
              <th className="px-6 py-4 text-left">Category</th>
              <th className="px-6 py-4 text-center">Stock</th>
              <th className="px-6 py-4 text-center">Unit</th>
              <th className="px-6 py-4 text-left">Branch</th>
              <th className="px-6 py-4 text-left">Latest purchase / stock value</th>
              <th className="px-6 py-4 text-left">Nearest expiry</th>
              <th className="px-6 py-4 text-center">Status</th>
              <th className="px-6 py-4 text-center">Action</th>
            </tr>
          </thead>

          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan="10" className="p-8 text-center text-gray-500">
                  No inventory items found.
                </td>
              </tr>
            ) : (
              items.map((item) => {
                const stock = Number(item.stock || 0);
                const minStock = Number(item.minStock || 0);
                const lowStock = stock < minStock;

                return (
                  <tr
                    key={item.id}
                    className="border-t border-white/10 transition hover:bg-white/5"
                  >
                    <td className="px-6 py-4 font-medium">{item.name}</td>
                    <td className="px-6 py-4">{item.department || "-"}</td>
                    <td className="px-6 py-4">{item.category || "-"}</td>
                    <td className="px-6 py-4 text-center">
                      {formatStock(stock)}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {item.unit || "-"}
                    </td>
                    <td className="px-6 py-4">{item.branch || "-"}</td>
                    <td className="px-6 py-4"><div>{item.latest_purchase_rate==null?'Rate not recorded':`₹${Number(item.latest_purchase_rate).toLocaleString('en-IN')} / ${item.latest_purchase_unit}`}</div><div className="text-xs text-gray-400">On-hand value: {item.remaining_stock_value==null?'Unknown':`₹${Number(item.remaining_stock_value).toLocaleString('en-IN',{maximumFractionDigits:2})}`}{item.value_complete===false?' (provisional)':''} · see lots</div></td>
                    <td className="px-6 py-4">{item.nearest_expiry||'—'}</td>

                    <td className="px-6 py-4 text-center">
                      <span
                        className={`rounded-full px-3 py-1 text-xs ${
                          lowStock
                            ? "bg-red-500/20 text-red-400"
                            : "bg-emerald-500/20 text-emerald-400"
                        }`}
                      >
                        {lowStock ? "Low Stock" : "Healthy"}
                      </span>
                    </td>

                    <td className="px-6 py-4 text-center"><TableActions>
                      <button onClick={()=>setLotItem(item)}>View stock lots & pricing</button>
                      <PermissionButton permissionModule="inventory"
                        onClick={() => onEdit(item)}
                        className="rounded-lg bg-amber-400 px-3 py-1.5 text-xs font-medium text-black transition hover:bg-amber-300"
                      >
                        Edit
                      </PermissionButton>
                    </TableActions></td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
